export type Subscription = {
	id: string;
	cancelAt?: string | null;
	status: "active" | "canceled" | "past_due" | "trialing" | "unpaid";
	interval: "MONTH" | "YEAR" | "LIFETIME" | "PROCESSING" | null;
	planTier: "PREMIUM" | "PLUS" | null;
	start_date: string;
	end_date: string;
};

export const checkForActiveSubscription = (
	subscription: Subscription | null,
): boolean => {
	if (!subscription) return false;

	if (subscription.interval === "LIFETIME") return true;

	const currentDate = new Date();
	const startDate = new Date(subscription.start_date);
	const endDate = new Date(subscription.end_date);

	return currentDate >= startDate && currentDate <= endDate;
};
